// frontend/src/components/import/PanelImportacion.jsx
import React, { useState } from 'react';
import { importarApi, adminApi } from '../../services/api';

function Seccion({ titulo, icono, children }) {
  return (
    <div style={{
      background:'#fff', borderRadius:12, padding:24,
      boxShadow:'0 1px 4px rgba(0,0,0,.08)', marginBottom:20,
    }}>
      <h3 style={{ fontSize:16, fontWeight:700, color:'#1a3a5c',
                   marginBottom:16, display:'flex', alignItems:'center', gap:8 }}>
        <span>{icono}</span> {titulo}
      </h3>
      {children}
    </div>
  );
}

// ── Panel de Importación CSV/Excel ────────────────────────
function ImportadorCSV() {
  const [archivo,     setArchivo]     = useState(null);
  const [anio,        setAnio]        = useState(new Date().getFullYear());
  const [estado,      setEstado]      = useState(null); // null | 'cargando' | 'ok' | 'error'
  const [resultado,   setResultado]   = useState(null);

  const handleSubir = async () => {
    if (!archivo) return;
    setEstado('cargando');
    setResultado(null);
    try {
      const data = await importarApi.subir(archivo, anio);
      setEstado(data.ok ? 'ok' : 'error');
      setResultado(data);
    } catch (err) {
      setEstado('error');
      setResultado({ mensaje: err.message });
    }
  };

  return (
    <Seccion titulo="Migración Inicial de Datos" icono="📥">
      <p style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>
        Sube el archivo Excel o CSV con los datos actuales del condominio.
        El sistema creará automáticamente las zonas, casas y registrará
        la deuda acumulada histórica como "Saldo Inicial".
      </p>

      {/* Plantilla de columnas esperadas */}
      <div style={{
        background:'#f0f9ff', border:'1px solid #bae6fd',
        borderRadius:8, padding:14, marginBottom:20, fontSize:12
      }}>
        <strong style={{ color:'#0369a1' }}>📋 Columnas requeridas en el archivo:</strong>
        <div style={{ marginTop:8, display:'flex', flexWrap:'wrap', gap:6 }}>
          {['quinta','identificador','propietario','email','telefono',
            'telefono_alt','zona','deuda_acumulada','notas'].map(col => (
            <code key={col} style={{
              background:'#e0f2fe', color:'#0c4a6e',
              padding:'2px 8px', borderRadius:4, fontSize:11
            }}>
              {col}
            </code>
          ))}
        </div>
      </div>

      <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:16 }}>
        <div style={{ flex:2 }}>
          <label style={labelStyle}>Archivo CSV o Excel (.xlsx)</label>
          <input
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={e => setArchivo(e.target.files[0])}
            style={{ ...inputStyle, padding:'7px 10px' }}
          />
        </div>
        <div style={{ flex:1, minWidth:120 }}>
          <label style={labelStyle}>Año Fiscal Base</label>
          <input
            type="number" value={anio} min="2000" max="2100"
            onChange={e => setAnio(parseInt(e.target.value))}
            style={inputStyle}
          />
        </div>
      </div>

      <button
        onClick={handleSubir}
        disabled={!archivo || estado === 'cargando'}
        style={{
          ...btnPrimario,
          opacity: (!archivo || estado === 'cargando') ? .5 : 1,
          padding:'10px 24px',
        }}
      >
        {estado === 'cargando' ? '⏳ Procesando…' : '🚀 Iniciar Migración'}
      </button>

      {/* Resultado */}
      {resultado && (
        <div style={{
          marginTop:16, padding:14, borderRadius:8,
          background: estado === 'ok' ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${estado === 'ok' ? '#bbf7d0' : '#fecaca'}`,
          fontSize:13,
        }}>
          <p style={{ fontWeight:600, color: estado === 'ok' ? '#15803d' : '#dc2626',
                      marginBottom: resultado.detalle ? 8 : 0 }}>
            {estado === 'ok' ? '✅' : '❌'} {resultado.mensaje}
          </p>
          {resultado.detalle && (
            <ul style={{ margin:0, paddingLeft:16, color:'#374151' }}>
              <li>Total en archivo: {resultado.detalle.total}</li>
              <li>Procesadas exitosamente: {resultado.detalle.procesadas}</li>
              <li>Con errores: {resultado.detalle.errores?.length || 0}</li>
            </ul>
          )}
        </div>
      )}
    </Seccion>
  );
}

// ── Facturación Anual en Lote ─────────────────────────────
function FacturacionLote() {
  const [anio,    setAnio]    = useState(new Date().getFullYear());
  const [estado,  setEstado]  = useState(null);
  const [msg,     setMsg]     = useState('');

  const ejecutar = async () => {
    if (!window.confirm(
      `¿Generar las cuotas anuales ${anio} para TODAS las casas?\n` +
      'Esta acción es idempotente — los cargos ya existentes no se duplican.'
    )) return;

    setEstado('cargando');
    try {
      const data = await adminApi.facturacionAnual(anio);
      setEstado('ok');
      setMsg(data.mensaje);
    } catch (err) {
      setEstado('error');
      setMsg(err.message);
    }
  };

  return (
    <Seccion titulo="Facturación Anual en Lote" icono="📅">
      <p style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>
        Genera la cuota anual de condominio para todas las casas activas
        según la tarifa vigente de su zona. Es seguro ejecutar múltiples veces —
        no crea duplicados.
      </p>
      <div style={{ display:'flex', gap:12, alignItems:'flex-end', flexWrap:'wrap' }}>
        <div>
          <label style={labelStyle}>Año Fiscal</label>
          <input type="number" value={anio} min="2000" max="2100"
                 onChange={e => setAnio(parseInt(e.target.value))}
                 style={{ ...inputStyle, width:120 }}/>
        </div>
        <button onClick={ejecutar} disabled={estado === 'cargando'}
                style={{ ...btnPrimario, padding:'9px 20px',
                         opacity: estado === 'cargando' ? .5 : 1 }}>
          {estado === 'cargando' ? '⏳ Procesando…' : '⚡ Ejecutar Facturación'}
        </button>
      </div>
      {msg && (
        <p style={{ marginTop:14, fontSize:13,
                    color: estado === 'ok' ? '#15803d' : '#dc2626' }}>
          {estado === 'ok' ? '✅' : '❌'} {msg}
        </p>
      )}
    </Seccion>
  );
}

// ── Cuota Extraordinaria ──────────────────────────────────
function CuotaExtraordinaria() {
  const [form,   setForm]   = useState({ monto:'', descripcion:'', anioFiscal: new Date().getFullYear() });
  const [estado, setEstado] = useState(null);
  const [msg,    setMsg]    = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const ejecutar = async () => {
    if (!form.monto || !form.descripcion) {
      alert('Completa el monto y la descripción.'); return;
    }
    if (!window.confirm(
      `¿Aplicar cargo de $${form.monto} a TODAS las casas?\nConcepto: "${form.descripcion}"`
    )) return;

    setEstado('cargando');
    try {
      const data = await adminApi.cuotaExtraordinaria({
        monto:       parseFloat(form.monto),
        descripcion: form.descripcion,
        anioFiscal:  form.anioFiscal,
        generadoPor: 'ADMIN',
      });
      setEstado('ok');
      setMsg(`✅ ${data.casas_afectadas} casas afectadas. Total generado: $${data.total_generado.toFixed(2)}`);
    } catch (err) {
      setEstado('error');
      setMsg(err.message);
    }
  };

  return (
    <Seccion titulo="Cuota Extraordinaria Global" icono="⚡">
      <p style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>
        Aplica un cargo extraordinario a todas las casas activas simultáneamente.
      </p>
      <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:12 }}>
        <div style={{ flex:1, minWidth:140 }}>
          <label style={labelStyle}>Monto (USD)*</label>
          <input type="number" step="0.01" min="0.01" value={form.monto}
                 onChange={e => set('monto', e.target.value)} style={inputStyle}/>
        </div>
        <div style={{ flex:1, minWidth:100 }}>
          <label style={labelStyle}>Año Fiscal</label>
          <input type="number" value={form.anioFiscal} min="2000" max="2100"
                 onChange={e => set('anioFiscal', parseInt(e.target.value))}
                 style={inputStyle}/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={labelStyle}>Descripción / Concepto*</label>
        <input type="text" value={form.descripcion}
               onChange={e => set('descripcion', e.target.value)}
               placeholder="ej. Reparación de portones — Junio 2025"
               style={inputStyle}/>
      </div>
      <button onClick={ejecutar} disabled={estado === 'cargando'}
              style={{ ...btnPrimario, background:'#b45309', padding:'9px 20px' }}>
        {estado === 'cargando' ? '⏳ Aplicando…' : '💥 Aplicar a Todas las Casas'}
      </button>
      {msg && (
        <p style={{ marginTop:14, fontSize:13,
                    color: estado === 'ok' ? '#15803d' : '#dc2626' }}>
          {msg}
        </p>
      )}
    </Seccion>
  );
}

// ── PANEL COMPLETO ────────────────────────────────────────
export default function PanelImportacion() {
  return (
    <div style={{ padding:24 }}>
      <h2 style={{ fontSize:20, fontWeight:700, color:'#1a3a5c', marginBottom:4 }}>
        Importación y Configuración
      </h2>
      <p style={{ fontSize:13, color:'#6b7280', marginBottom:24 }}>
        Herramientas administrativas de alto impacto. Úsalas con precaución.
      </p>
      <ImportadorCSV/>
      <FacturacionLote/>
      <CuotaExtraordinaria/>
    </div>
  );
}

const labelStyle = {
  display:'block', fontSize:11, fontWeight:600,
  color:'#374151', marginBottom:4,
};
const inputStyle = {
  width:'100%', padding:'9px 12px', borderRadius:8,
  border:'1px solid #d1d5db', fontSize:13, background:'#fff',
  color:'#374151', boxSizing:'border-box',
};
const btnPrimario = {
  background:'#1a3a5c', color:'#fff', border:'none',
  borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:600,
};
